// extracted by mini-css-extract-plugin
module.exports = {"Title":"Grant_Title__72_vB"};